// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MttF","label":"styles_label__2BTjW"};